var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15.9999109px",
    height: "20px",
    viewBox: "0 0 15.9999109 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u7ED3\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00207164,0 C8.12102135,0 8.23997107,0.0159765243 8.32864267,0.0479295729 L15.6775722,2.69090316 C15.8570782,2.75709162 16.0041433,2.97391588 15.9998178,3.17476361 L15.9998178,14.1848712 C15.9998178,14.3880013 15.8765427,14.6527551 15.7273149,14.7760026 L8.2724119,19.9064232 C8.19887935,19.968047 8.09939413,20 7.99990892,20 C7.9004237,20 7.80310121,19.968047 7.72740594,19.9064232 L0.27250298,14.7760026 C0.123275158,14.6504728 0,14.3857189 0,14.1848712 L0,3.17476361 C0,2.97391588 0.1470651,2.75480926 0.326571032,2.69090316 L7.67550061,0.0479295729 C7.76417221,0.0159765243 7.88312193,0 8.00207164,0 Z M8.00207164,1.66840561 L1.55715989,3.98728399 L1.55715989,13.746658 L8.00207164,18.0462993 L14.4469834,13.746658 L14.4469834,3.98728399 L8.00207164,1.66840561 Z M12.8454141,5.89200041 C13.1690413,6.15053144 13.2218122,6.62246395 12.9632812,6.94609118 L8.19829459,12.910866 C7.93644911,13.2386422 7.45666115,13.2879003 7.13367683,13.0201664 L3.53583476,10.037779 C3.2169388,9.77343403 3.17271645,9.30062387 3.43706138,8.98172791 C3.70140631,8.66283195 4.17421647,8.6186096 4.49311243,8.88295452 L7.5024736,11.3769793 L11.7913233,6.00986749 C12.0498544,5.68624027 12.5217869,5.63346938 12.8454141,5.89200041 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/basic.52cdd37611039a69d13d41d51f8863aa.svg";
export { ForwardRef as ReactComponent };